import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import Chip from "@mui/material/Chip";
import CloseIcon from "@mui/icons-material/Close";
import Container from "@mui/material/Container";
import top100Films from "./tempData";
import SearchIcon from "@mui/icons-material/Search";
import useMediaQuery from "@mui/material/useMediaQuery";

const SearchChips = ({ option, getTagProps, index }) => {
  return (
    <Chip
      variant="outlined"
      sx={{
        borderColor: "#255CCE",
        backgroundColor: "#255CCE1A",
        fontSize: "16px",
        lineHeight: "24px",
        height: "36px",
        borderRadius: "4px",
        padding: "8px",
        "& .MuiChip-deleteIcon": {
          color: "#1F1F1F!important",
        },
      }}
      deleteIcon={
        <CloseIcon
          sx={{
            width: "16px",
            height: "16px",
          }}
        />
      }
      label={option.title}
      {...getTagProps({ index })}
    />
  );
};

const populateSearchChips = (type, value, getTagProps) => {
  switch (type) {
    case "all":
      const chips = value.map((option, index) => (
        <SearchChips option={option} index={index} getTagProps={getTagProps} />
      ));
      return chips;

    case "partial":
      return [
        <SearchChips option={value[0]} index={0} getTagProps={getTagProps} />,
        <SearchChips option={value[1]} index={1} getTagProps={getTagProps} />,
        <SearchChips
          option={{ title: `${value.length - 2} more` }}
          index={2}
          getTagProps={getTagProps}
        />,
      ];

    default:
      break;
  }
};

function SearchField({ label, sx, resetFilter }) {
  const [open, setOpen] = React.useState(false);
  const [isFocused, setIsFocused] = React.useState(false);
  const mobMatch = useMediaQuery("(max-width:600px)");

  const [selectedTags, setSelectedTags] = useState();
  const options = top100Films.map((option) => {
    const firstLetter = option.title[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  React.useEffect(() => {
    if (resetFilter) {
      // reset
    }
  }, [resetFilter]);

  return (
    <Autocomplete
      sx={{
        width: { sm: "522px", md: "702px", xl: "803px" },
        padding: "0px",
        "& .Mui-focused": {
          borderColor: "#255CCE",
        },
        "& .MuiAutocomplete-inputRoot": {
          height: "46.29px",
          // padding: "0px",
        },
        "& .MuiInputLabel-root": {
          lineHeight: "1",
          overflow: "visible",
        },
        "& .MuiFormControl-root": {
          "& .MuiOutlinedInput-root": {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            flexWrap: "nowrap",
            paddingX: "0px",
            "& .MuiOutlinedInput-input:placeholder": {
              color: "#1f1f1f",
            },
            // "& .MuiOutlinedInput-notchedOutline span": {
            //   marginRight: "0px",
            // },
          },
        },
        ...sx,
      }}
      limitTags={2}
      multiple
      onChange={(event, value) => setSelectedTags({ ...selectedTags, value })}
      clearIcon={null}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      popupIcon={
        mobMatch ? (
          <SearchIcon
            sx={{
              color: isFocused ? "primary.main" : "#616161",
              transform: open && "rotate(180deg)",
            }}
          />
        ) : null
      }
      id="tags-outlined"
      options={options.sort(
        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
      )}
      getOptionLabel={(option) => option.title}
      filterSelectedOptions
      groupBy={(option) => option.firstLetter}
      renderTags={(value, getTagProps) => {
        return (
          <Container
            disableGutters={true}
            sx={{
              "&::-webkit-scrollbar": {
                display: "none",
              },
              margin: "0 3px",
              display: "flex",
              overflow: "scroll",
              width: "fit-content",
            }}
          >
            {populateSearchChips(
              value.length > 2 ? "partial" : "all",
              value,
              getTagProps
            )}
          </Container>
        );
      }}
      renderInput={(params) => (
        <TextField
          sx={{
            width: "100%",
            height: "46.29px",
            padding: "0px",
          }}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          {...params}
          InputLabelProps={{
            sx: {
              fontSize: "16px",
              lineHeight: "24px",
              color: "#616161",
            },
          }}
          label={isFocused ? "Search Machinery" : label}
        />
      )}
    />
  );
}

export default SearchField;
